module.exports = __webpack_public_path__ + "static/media/WoollenLandA0003.cfff45f2.png";